import { render } from "./Empresas.vue?vue&type=template&id=40cea6b7&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"

import "./Empresas.vue?vue&type=style&index=0&id=40cea6b7&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cea6b7"]])

export default __exports__